import styled from "styled-components";

import Button, { Link } from "ds/Button";
import * as Dialog from "ds/Dialog";

export const AdvancedDialogOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
  padding-top: 8px;
  padding-bottom: 8px;
`;

export const CustomDialogContent = styled(Dialog.Content)`
  width: initial;
  max-width: 380px;
`;

export const DialogOptionsCell = styled.div`
  width: 100px;
`;

export const DialogOptionsButton = styled(Button)`
  justify-content: flex-start;
  padding: 0;
  font-size: 15px;
  color: var(--mode-text-neutral-default) !important;
`;
export const AdvancedSignalsDoc = styled.div`
  max-width: 380px;
`;

export const DocButton = styled(Link)`
  display: flex;
  justify-content: flex-start;
  width: fit-content;
`;
